import WrapWithDropdownBody from "../WrapWithDropdownBody.vue";
import { SelectedSection } from "../sections";
import PortfolioFilterItem from "../items/PortfolioFilterItem.vue";
import ListSection from "../sections/ListSection.vue";
export default {
  name: "PortfolioFilterBody",
  components: {
    WrapWithDropdownBody,
    SelectedSection,
    PortfolioFilterItem,
    ListSection
  },
  emits: ["clear", "discard", "restoreSearch", "select", "deselect", "selectAll", "apply", "search", "hidden", "closeDropdown", "selectOnly"],
  props: {
    title: {
      type: String,
      default: ""
    },
    selected: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    isModified: {
      type: Boolean,
      default: false
    },
    // Filter.pendingChanges: { count, text } | string | null
    pendingChanges: {
      type: [Object, String],
      default: null
    },
    searching: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: [String, Array],
      default: ""
    }
  },
  computed: {
    getListTitle() {
      return this.searching ? `${this.list.length} PORTFOLIOS FOUND` : "PORTFOLIOS";
    }
  }
};